import { AuthenticateService } from '../../../services/authenticate.service';
import { Usuario } from 'src/models/usuario.model';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonFab, ModalController, NavParams, ToastController } from '@ionic/angular';
import { Util } from '../../../util/util';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { StorageService } from 'src/services/storage.service';

// import { FormsModule } from '@angular/forms';

@Component({
    selector: 'modal-fab',
    templateUrl: 'modal-fab-component.html',
    styleUrls: ['modal-fab-component.scss']
})

export class ModalFabComponent {

    @ViewChild('fabBottom') fabBottom: IonFab;


    titulo = 'Selecionar';
    tipo: any;
    icone: any;
    texto: any;

    familiar: any = {};
    listTypes: any[] = [];
    skeletonLoading = false;
    showAdd = false;
    code = '';
    notClose: any;

    constructor(private storage: StorageService,
        private toastController: ToastController,
        private modalController: ModalController,
        private navParams: NavParams,
        public router: Router,
        private auth: AuthenticateService) {

        this.tipo = this.navParams.get('tipo');
        this.familiar = this.navParams.get('familiar');
        this.titulo = this.navParams.get('titulo');
        this.notClose = this.navParams.get('notClose');

    }

    ngOnInit() {
    }

    ionViewDidEnter() {
        if (this.tipo == 'meus-registros') {
            this.listTypes = [
                {
                    id: 1,
                    rota: '/contatos-emergencia',
                    icone: '/assets/imgs/icons/icon-contato-agenda.png',
                    nome: 'Contatos emergência',
                    texto: 'Adicionar meus contatos importantes'
                },
                {
                    id: 2,
                    rota: '/contatos-profissionais',
                    icone: '/assets/imgs/icons/icon-contato-add.png',
                    nome: 'Contatos profissionais',
                    texto: 'Contato dos seus profissionais de saúde'
                },

            ];
        }
    }

    abrirOpcao(evt, item) {
        this.modalController.dismiss(item);
    }
    getTextFormat(text) {
        return Util.getTextFormat(text);
    }

    openTermo(tipoTermo) {
        this.modalController.dismiss(tipoTermo);
    }


    fechar() {
        this.modalController.dismiss();
    }

    acceptTerm() {
        localStorage.setItem('_termo', '1');
        this.modalController.dismiss();
    }
}
